export const extractNames = (user) => {
    return Object.assign(Object.assign({}, user), { firstName: user.fullName.split(" ")[0], lastName: user.fullName.split(" ")[1] || "" });
};
